var _defs, _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas5Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 8.3px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #323d88;\r\n        stroke: #323c88;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 8.71px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #323a89;\r\n        stroke-width: 50.14px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37,
    y: 337.64,
    width: 1053,
    height: 720.8,
    rx: 3.83,
    ry: 3.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m391.13,334.51v-146.37c0-9.17,7.43-16.6,16.6-16.6h305.27c9.17,0,16.6,7.43,16.6,16.6v152.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.13,672.48h236.87v65.17h-236.87c-2.87,0-5.2-2.33-5.2-5.2v-54.77c0-2.87,2.33-5.2,5.2-5.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m698.1,793.51c-47.95,3.78-93.1-42.04-93.1-93.1s45.08-96.98,93.1-93.1c30.46,2.45,57.91,24.64,72.24,56.28-24.08-.15-48.16-.27-72.24-.42-1.85,1.4-18.62,14.44-18.62,37.24,0,2.33.37,23.55,18.62,37.24,23.97.29,47.93.6,71.9.89-1.1,2.35-25.1,51.28-71.9,54.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas5Icon);
export default __webpack_public_path__ + "static/media/pas5Icon.972eadc5ea78e7d1e137925d5272300a.svg";
export { ForwardRef as ReactComponent };